import React from "react";
import ProgramDetailsSection from "../../../../components/template/ProgramDetailSection";

const Renew = () => {
  return (
    <ProgramDetailsSection
      title="RENEW"
      tagline="Executive Renewal Workshop"
      highlights={[
        "Science-Based",
        "Led by IIT/IIM Alumni",
        "Especially Designed for Leaders",
      ]}
      description="RENEW is an immersive executive renewal experience that enables leaders to recharge their energy, reconnect with their purpose, and build a sustainable foundation for high-performance leadership."
      duration="1.5 Days"
      focusAreas={[
        "Holistic Health & Vitality",
        "Stress Management & Recovery",
        "Energy, Focus & Effectiveness",
        "Self-Assessment & Reflection",
        "Vision & Personal Goal Alignment",
      ]}
      outcomes={[
        "Recharge physical, mental, and emotional energy for sustained leadership performance.",
        "Gain deeper clarity on personal priorities, aspirations, and leadership effectiveness.",
        "Create a practical roadmap for greater wellbeing, focus, and purposeful growth.",
      ]}
      images={[
        "../../../cw/CW15.JPG",
        "../../../cw/CW3.JPG"
      ]}
    />
  );
};

export default Renew;